// src/lib/managers/user/types/const.ts

import { MailvistaUrls, Url } from "./settings";

/**
 * Enum defining types of AI suggestions
 */
export enum AISuggestion {
    Conversation = "conversation",
    CustomViewCreation = "customViewCreation",
}

// Sample suggestions for conversations with AI

export const CONVERSATION_SUGGESTION: string[] = [
    // Email Search
    "Trouve tous les emails avec pièces jointes de cette semaine",
    "Montre-moi les emails non lus de <expéditeur>",
    "Recherche les emails contenant <mot-clé> depuis le <date>",
    "Affiche les emails reçus de <expéditeur> entre <date début> et <date fin>",
    "Trouve les emails marqués comme focus ce mois-ci",
    "Supprime les emails contenant <spam> de <expéditeur indésirable>",
    "Marque comme lus tous les emails de <expéditeur>",
    "Trouve les emails non traités contenant <urgent> ou <important>",
    "Affiche les emails de <client@entreprise.com> depuis <date>",
    "Recherche <facture> dans les emails de <comptabilité@exemple.com>",

    // Agenda Creation
    "Crée une réunion <Titre> le <date> de <HH:mm> à <HH:mm>",
    "Programme un rendez-vous avec <participant> demain à <HH:mm>",
    "Planifie <Événement> le <jour> à <lieu> avec <participant>",
    "Organise une conférence call <Sujet> avec <participant>",
    "Crée un rappel <Tâche> pour le <date> à <HH:mm>",
    "Programme une formation <Formation> à <lieu> de <HH:mm> à <HH:mm>",
    "Planifie un déjeuner avec <participant> le <jour> à <HH:mm>",
    "Organise <Présentation> en salle <numéro> le <date>",
    "Crée un entretien avec <participant> à <HH:mm>",

    // Agenda Consultation
    "Montre-moi mon planning du <date début> au <date fin>",
    "Affiche mes rendez-vous d'aujourd'hui",
    "Consulte mon agenda de la semaine prochaine",
    "Vérifie mes disponibilités entre <HH:mm> et <HH:mm> demain",
    "Montre-moi tous mes événements du <date>",
    "Affiche mon planning des <X> prochains jours",
    "Consulte mes réunions du <jour> au <jour>",
    "Vérifie mon agenda pour les <X> prochaines heures",
    "Montre-moi mes engagements de ce week-end",
    "Affiche mes activités prévues cette semaine",

    // Free Time Search
    "Trouve-moi <X> minutes libres entre <HH:mm> et <HH:mm>",
    "Cherche <X> heures disponibles dans les <X> prochains jours",
    "Identifie des créneaux de <X> minutes pour appel client",
    "Trouve <X> minutes libres demain entre <HH:mm> et <HH:mm>",
    "Cherche <X> heures disponibles cette semaine après <HH:mm>",
    "Identifie des plages de <X> minutes avant <HH:mm> aujourd'hui",
    "Trouve <X> minutes libres le <date> matin",
    "Cherche <X> heures disponibles entre <date> et <date>",
    "Identifie des créneaux de <X> minutes en fin de journée",
    "Trouve <X> minutes libres pour rattraper le travail en retard",

    // General Chat
    "Explique-moi comment optimiser ma gestion d'emails quotidienne",
    "Donne-moi des conseils pour mieux structurer mon agenda",
    "Comment puis-je automatiser mes tâches répétitives?",
];

// Sample suggestions for creating custom views
export const CUSTOMVIEW_CREATION_SUGGESTION: string[] = [
    // "Tous les mails contenant des pièces jointes",
    // "Messages des 7 derniers jours",
    "Emails de mon équipe concernant le projet Alpha",
    // "Correspondance avec nos clients prioritaires",
    // "Messages marqués comme importants ou non-lus",
    // "Emails contenant des liens vers des documents",
    "Messages mentionnant des délais ou échéances",
    // "Correspondance avec le département RH",
    "Emails contenant des informations de réunion",
    // "Messages nécessitant une réponse rapide",
    "Emails relatifs au budget trimestriel",
    "Communications avec les fournisseurs externes",
    "Messages concernant les problèmes techniques",
    "Emails contenant des rapports ou statistiques",
    "Correspondance liée aux ressources humaines",
];

export const MAILVISTA_URLS: Record<MailvistaUrls, Url> = {
    [MailvistaUrls.OFFICIALSITE]: {
        id: MailvistaUrls.OFFICIALSITE,
        url: "https://www.mailvista.ai",
        title: "Site Internet",
    },
    [MailvistaUrls.CONDITIONGENERALESUTILISATION]: {
        id: MailvistaUrls.CONDITIONGENERALESUTILISATION,
        url: "https://www.mailvista.ai/documents/CGU_B2B_Mailvista.pdf",
        title: "Conditions générales d'utilisation",
    },
    [MailvistaUrls.CONDITIONGENERALESUTILISATIONPARTICULIER]: {
        id: MailvistaUrls.CONDITIONGENERALESUTILISATIONPARTICULIER,
        url: "https://www.mailvista.ai/documents/CGU_B2C_Mailvista.pdf",
        title: "Conditions générales d'utilisation",
    },
    [MailvistaUrls.CONDITIONGENERALESUTILISATIONENTREPRISE]: {
        id: MailvistaUrls.CONDITIONGENERALESUTILISATIONENTREPRISE,
        url: "https://www.mailvista.ai/documents/CGU_B2B_Mailvista.pdf",
        title: "Conditions générales d'utilisation",
    },
    [MailvistaUrls.POLITIQUECONFIDENTIALITE]: {
        id: MailvistaUrls.POLITIQUECONFIDENTIALITE,
        url: "https://www.mailvista.ai/documents/Politique_Confidentialite_Mailvista.pdf ",
        title: "Politique de confidentialité",
    },
    [MailvistaUrls.ONBOARDINGVIDEO]: {
        id: MailvistaUrls.ONBOARDINGVIDEO,
        url: "https://www.youtube.com/embed/mxr4Pd1drzU",
        title: "Videos d accueil Mailvista",
    },
    [MailvistaUrls.MENTIONLEGALEWEB]: {
        id: MailvistaUrls.MENTIONLEGALEWEB,
        url: "https://www.mailvista.ai/documents/Mentions_Legales_Site__Web_Mailvista.pdf",
        title: "Mentions légales Site web",
    },
    [MailvistaUrls.MENTIONLEGALEAPPLICATION]: {
        id: MailvistaUrls.MENTIONLEGALEAPPLICATION,
        url: "https://www.mailvista.ai/documents/Mentions_Legales_App_Mailvista.pdf",
        title: "Mentions légales Application",
    },
};
